import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import get from 'lodash/get';
import { CaretDownOutlined } from '@ant-design/icons';

import Button from '@/components/common/button';
import SoldiIcon from '@/assets/images/soldi-logo.svg';
import NotificationIcon from '@/assets/images/icons/icons-bell-outlined.svg';
import ActiveIcon from '@/assets/images/icons/blue-light-badge.svg';
import UserDefaultAvatar from '@/assets/images/default-avatar.png';
import ActiveBusinessSelector from '@/components/business/active-business-selector';

import './header.scss';
import configs from '../../config';
import Dropdown from '@/components/common/dropdown';
import SignOut from '@/components/sign-out';

const Header = () => {
  const authenticate = useSelector((state) => state.authenticate);

  const firstName = get(authenticate, 'user.first_name', '');
  const lastName = get(authenticate, 'user.last_name', '');
  const isActive = get(authenticate, 'user.is_active', false);
  const userAvatar = get(authenticate, 'user.files[0].path', UserDefaultAvatar);

  return (
    <nav className="nav-top">
      <div className="logo-section">
        <Link to="/" className="text-center">
          <img src={SoldiIcon} alt="Soldi logo" className="logo" />
        </Link>
      </div>
      <div className="main-section">
        <ActiveBusinessSelector />

        <div className="rest" />

        {configs.enabledComponents === 'all' && (
          <div className="action-area">
            <Button type="primary" size="small">
              <img src={NotificationIcon} alt="search icon" className="icon" />
            </Button>
          </div>
        )}

        <Dropdown
          menu={
            <Menu>
              <Menu.Item>
                <Button type="text" size="large" block className="justify-left">
                  Profile
                </Button>
              </Menu.Item>
              <Menu.Item>
                <SignOut />
              </Menu.Item>
            </Menu>
          }
        >
          <div className="user-info pointer">
            <span className="username">{`${firstName} ${lastName}`}</span>
            <div className="online-status mh-8">
              <div className="avatar">
                <img src={userAvatar} alt="avatar" />
              </div>
              {isActive && (
                <span className="is-active">
                  <img src={ActiveIcon} alt="online" />
                </span>
              )}
            </div>
            <CaretDownOutlined className="text-18 color-white" />
          </div>
        </Dropdown>
      </div>
    </nav>
  );
};

export default Header;
